module.exports = __webpack_public_path__ + "static/img/szafa_18.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/szafa/szafa_18.svg
// module id = mONK
// module chunks = 0